module.exports = __webpack_public_path__ + "static/img/product_anchorIn.8c22ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_anchorIn.png
// module id = iN2s
// module chunks = 0